import { Observer } from 'mobx-react';
import * as React from 'react';
import { ScrollSync } from 'react-scroll-sync';

import { LeftSideWrapper, RightSideWrapper, TableWrapper } from 'src/modules/racersTable/components';
import { onHorizontalScroll } from 'src/modules/racersTable/utils';

import { RightSide, LeftSide, RightHeader, LeftHeader } from '../../components/Table';

import { currentDistance } from '../../derivations';

export const Table = () => (
  <Observer>
    {() => {
      const distance = currentDistance.model.get();
      if (!distance) return null;

      return (
        <ScrollSync onSync={onHorizontalScroll}>
          <TableWrapper>
            <LeftHeader distance={distance} />
            <RightSideWrapper sticky>
              <RightHeader distance={distance} />
            </RightSideWrapper>
            <LeftSideWrapper>
              <LeftSide distance={distance} />
            </LeftSideWrapper>
            <RightSideWrapper withBorder>
              <RightSide distance={distance} />
            </RightSideWrapper>
          </TableWrapper>
        </ScrollSync>
      );
    }}
  </Observer>
);
